import { del, get, head, patch, post, put } from 'aws-amplify/api';

type ApiMethod = 'get' | 'post' | 'put' | 'head' | 'del' | 'patch';
type ApiName = 'geonius' | 'mapbox' | 'capella' | 'atlas' | 'geospatial';

const defaultHeaders = {
  'Content-Type': 'application/json',
};
type RestApiResponse = Awaited<ReturnType<typeof get>['response']>;

const methodMap = {
  get,
  post,
  put,
  del,
  patch,
  head,
} as const;

export const wrapRequest = async <T = any>(
  apiMethod: ApiMethod,
  apiName: ApiName,
  path: string,
  init: {
    headers?: Record<string, any>;
    body?: any;
    queryStringParameters?: Record<string, any>;
  } = {}
): Promise<T> => {
  const headers = {
    ...defaultHeaders,
    ...init.headers,
  };

  const operation = methodMap[apiMethod]({
    apiName,
    path,
    options: {
      headers,
      body: init.body,
      queryParams: init.queryStringParameters,
    },
  });

  const response = (await operation.response) as RestApiResponse;
  if (!response.body) {
    return undefined as T;
  }

  const bodyText = await response.body.text();

  if (!bodyText || bodyText.trim() === '') {
    return undefined as T;
  }

  try {
    return JSON.parse(bodyText) as T;
  } catch {
    return bodyText as unknown as T;
  }
};
